<template>
  <r-video src="/video/home.mp4" poster="img/home/videoPoster.png" />
</template>

<script>
import RVideo from './Video.vue';

export default {
  components: {
    RVideo,
  },
};
</script>
